<template>
    <v-app-bar app :clipped-left="$vuetify.breakpoint.lgAndUp"  color="blue darken-3" dark fixed>
        <slot></slot>

        <v-spacer></v-spacer>

        <v-menu left top>
            <template v-slot:activator="{ on }">

                <v-btn color="primary" text  v-on="on">
                    <v-avatar size="24px" tile>
                        <img :src="defaultLanguage" alt="Vuetify">
                    </v-avatar>
                </v-btn>
            </template>
            <v-list>
                <v-list-item
                        :key="index"
                        @click="changeLanguage(item)"
                        v-for="(item, index) in languages"
                >
                    <v-list-item-avatar size="24px" tile>
                        <img :src="require('@/assets/flags/'+item.value+'.png')" alt="John">
                    </v-list-item-avatar>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    export default {
        name: "ToolBar",
        data() {
            return {
                languages: [
                    {
                        text: "English",
                        value: "en"
                    },
                    {
                        text: "Chinese",
                        value: "cn"
                    }
                ]
            }
        },
        computed:{
            defaultLanguage(){
                return require("@/assets/flags/" + this.$vuetify.lang.current + ".png");
            },
        },
        methods: {
            changeLanguage(item) {
                this.$vuetify.lang.current = "" + item.value;
            },
        }
    }
</script>

<style scoped>

</style>
